export default "__VITE_ASSET__xlhqm1vW__"